import React from 'react';
import { Button, ComponentLevelNotification, Hint, Surface } from '@americanexpress/dls-react';
import { IconCancelCircle, IconPlusCircle } from '@americanexpress/dls-icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { FieldArray, useFormikContext } from 'formik';
import { InputField } from '@cim-ui/cim-shared';
const MAX_SECONDARY_EMAILS = 10;
const OnboardingEmails = () => {
  const {
    formatMessage
  } = useIntl();
  const {
    errors,
    touched,
    submitCount,
    values
  } = useFormikContext();
  const secondaryEmailsCount = Array.isArray(values.secondaryEmails) ? values.secondaryEmails.length : 0;
  const secondaryEmailsError = errors.secondaryEmails;
  const shouldShowSecondaryEmailsError = typeof secondaryEmailsError === 'string' && (submitCount > 0 || Boolean(touched.secondaryEmails));
  const canAddSecondaryEmail = secondaryEmailsCount < MAX_SECONDARY_EMAILS;
  const secondaryEmailsLegendId = 'secondaryEmails-legend';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputField, {
    name: "primaryEmail",
    label: formatMessage({
      id: 'registration.primaryEmail'
    }),
    className: "col-md-12 margin-responsive-t",
    autoComplete: "email",
    type: "email",
    "aria-required": true,
    isRequired: true
  }), /*#__PURE__*/React.createElement(FieldArray, {
    name: "secondaryEmails"
  }, arrayHelpers => {
    const {
      push,
      remove
    } = arrayHelpers;
    return /*#__PURE__*/React.createElement(Surface, {
      variant: "fg-subtle",
      className: "col-md-12 pad-2-t"
    }, /*#__PURE__*/React.createElement("div", {
      role: "group",
      "aria-labelledby": secondaryEmailsLegendId
    }, /*#__PURE__*/React.createElement("div", {
      id: secondaryEmailsLegendId,
      className: "sr-only"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.secondaryEmails.legend"
    })), shouldShowSecondaryEmailsError && /*#__PURE__*/React.createElement(ComponentLevelNotification, {
      id: "secondaryEmails-error",
      className: "pad-1-tb",
      status: "error",
      role: "alert"
    }, secondaryEmailsError), secondaryEmailsCount > 0 && /*#__PURE__*/React.createElement("div", {
      className: "margin-responsive-t pad-2-l"
    }, /*#__PURE__*/React.createElement(Hint, {
      className: "color-text-brand-alt"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.secondaryEmails.hint"
    }))), Array.isArray(values.secondaryEmails) && values.secondaryEmails.length > 0 && values.secondaryEmails.map((_event, idx) => {
      const eventKey = `event-${idx}`;
      return /*#__PURE__*/React.createElement("div", {
        className: "margin-responsive-t flex flex-align-center",
        key: eventKey
      }, /*#__PURE__*/React.createElement(InputField, {
        name: `secondaryEmails[${idx}]`,
        label: formatMessage({
          id: `registration.secondaryEmail${idx + 1}`
        }),
        className: "col-md-11 pad-2-l",
        autoComplete: "email",
        type: "email",
        "aria-required": true,
        isRequired: true
      }), /*#__PURE__*/React.createElement(Button, {
        type: "button",
        variant: "tertiary",
        className: "margin-3-t",
        onClick: () => remove(idx),
        "aria-label": formatMessage({
          id: 'registration.removeSecondaryEmail'
        }),
        icon: /*#__PURE__*/React.createElement(IconCancelCircle, {
          color: "brand",
          size: "md",
          isFilled: false,
          title: formatMessage({
            id: 'iconCancelCircleDescription'
          }),
          titleId: formatMessage({
            id: 'iconCancelCircleTitle'
          })
        })
      }));
    }), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      variant: "secondary",
      onClick: () => {
        if (!canAddSecondaryEmail) return;
        push('');
      },
      "aria-disabled": !canAddSecondaryEmail,
      className: "flex flex-align-center margin-responsive-t",
      iconPosition: "end",
      icon: /*#__PURE__*/React.createElement(IconPlusCircle, {
        color: "brand",
        size: "md",
        title: formatMessage({
          id: 'iconPlusCircleDescription'
        }),
        titleId: formatMessage({
          id: 'iconPlusCircleTitle'
        })
      })
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.addSecondaryEmail"
    }))));
  }));
};
export default OnboardingEmails;